import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-display",class:_vm.fileHeader && _vm.fileHeader === 'data:application/pdf;base64' && 'is-pdf'},[(_vm.fileSource)?_c('object',[_c('embed',{attrs:{"src":_vm.fileSource}})]):_vm._e(),(_vm.showCancelButton)?_c(VBtn,{staticClass:"cancel-button",attrs:{"icon":""},on:{"click":_vm.removeFile}},[_c(VIcon,[_vm._v("mdi-close")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }